// 追従(CookiePolicy)の表示
// jQuery(function($) {

// 	if ( $('#cookiePolicy').length > 0 ) {
// 		var cookiePolicy = $('#cookiePolicy');
// 		cookiePolicy.hide();
// 		if(localStorage.getItem('cookieUse') === null) {

// 			// スクロール時の表示・非表示
// 			$(window).on("scroll", dispAgree);

// 			// 同意ボタンクリック
// 			$('#cookie_agree').on("click", function() {
// 				$(window).off("scroll", dispAgree);
// 				localStorage.setItem('cookieUse', 'agree');
// 				cookiePolicy.hide();
// 			})
// 		}

// 		//スクロールが100に達したらクッキー同意を表示
// 		function dispAgree() {
// 			if ($(this).scrollTop() > 100) {
// 				cookiePolicy.fadeIn();
// 			} else {
// 				cookiePolicy.fadeOut();
// 			}
// 		}
// 	}
// });

// ページ内アンカーリンクのスクロールエフェクト
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定)
jQuery(function ($) {
  // var headerHeight = 0; // ヘッダー追従でない場合
  var headerHeight = $("header").innerHeight(); // ヘッダー追従の場合
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// // ブログサムネイル 中心でトリミング
// jQuery(function($) {
//     if ( $('.obj_image').length > 0 ) {
//         objectFitImages('.obj_image');
//     }
// });

// 追従CTAバナーの表示
jQuery(function ($) {
  if ($("#cta_banner").length > 0) {
    var topBtn = $("#cta_banner");
    topBtn.css("display", "none");
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
  }
});

// ページトップボタンの表示
// jQuery(function($) {

// 	if ( $('#pageup').length > 0 ) {
// 		var topBtn = $('#pageup');
// 		topBtn.css("display", "none");
// 		//スクロールが100に達したらボタン表示
// 		$(window).scroll(function () {
// 			if ($(this).scrollTop() > 100) {
// 				topBtn.fadeIn();
// 			} else {
// 				topBtn.fadeOut();
// 			}
// 		});
// 		//スクロールしてトップ
// 		topBtn.click(function () {
// 			$('body,html').animate({
// 				scrollTop: 0
// 			}, 500);
// 			return false;
// 		});
// 	}
// });

// ヘッダーの固定エフェクト
jQuery(function ($) {
  var $header = $("header");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 50) {
      $header.addClass("fixed");
    } else {
      $header.removeClass("fixed");
    }
  });
});

// ヘッダーのメガメニューの指定
// jQuery(function ($) {
//   $(document).ready(function () {
//     function checkScreenWidth() {
//       if (window.innerWidth >= 769) {
//         $(".parent_menu").hover(
//           function () {
//             $("header").addClass("parent_hover");
//           },
//           function () {
//             $("header").removeClass("parent_hover");
//           }
//         );
//       } else {
//         $("header").removeClass("parent_hover");
//       }
//     }

//     checkScreenWidth();

//     $(window).resize(function () {
//       checkScreenWidth();
//     });
//   });
// });

// レスポンシブ画像切り替え imgにclass「js-image-switch」
jQuery(function ($) {
  if ($(".js-image-switch").length > 0) {
    var $elem = $(".js-image-switch");
    var sp = "_sp.";
    var pc = "_pc.";
    // 画像を切り替えるウィンドウサイズ
    var replaceWidth = 768;

    function imageSwitch() {
      var windowWidth = parseInt($(window).width());
      $elem.each(function () {
        var $this = $(this);
        if (windowWidth >= replaceWidth) {
          $this.attr("src", $this.attr("src").replace(sp, pc));
        } else {
          $this.attr("src", $this.attr("src").replace(pc, sp));
        }
      });
    }
    imageSwitch();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        imageSwitch();
      }, 200);
    });
  }
});

// アコーディオンの起動
// jQuery(function($) {

// 	if ( $('dl.accordion dt').length > 0 ) {

// 		$("dl.accordion dt").click(function(){
// 			$(this).next("dd").slideToggle();
// 			$(this).toggleClass("open");
// 		});
// 	}
// });
jQuery(function ($) {
  if ($(".parent_menu").length > 0) {
    function checkWidth() {
      if ($(window).width() <= 768) {
        $(".parent_menu")
          .off("click")
          .on("click", function () {
            const subMenu = $(this).find(".sub_menu");
            subMenu.slideToggle(function () {
              if (subMenu.is(":visible")) {
                $(this).css("display", "flex");
              }
            });
            $(this).toggleClass("open");
          });
      } else {
        $(".parent_menu").off("click");
        $(".parent_menu").removeClass("open");
        $(".sub_menu").hide();
        $(".sub_menu").css("display", "flex");
      }
    }

    checkWidth();

    $(window).resize(function () {
      checkWidth();
    });
  }
});

// ドロワーメニュー
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");

      if ($(this).hasClass("toggle_active")) {
        $("nav").addClass("is_open");
        $("nav").removeClass("is_close");
      } else {
        $("nav").removeClass("is_open");
        $("nav").addClass("is_close");
      }
    });

    $("#drawer_layer").click(function () {
      $(this).fadeOut();
      $("#toggle").removeClass("toggle_active");
      $("body").removeClass("drawer_open");
      $("nav").removeClass("is_open");
      $("nav").addClass("is_close");
    });

    // エリア内リンク用
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});

// サービス下層＞実績スライダーのドラッグスクロール
jQuery(function ($) {
  if ($(".sec_achievements").length > 0) {
    jQuery.prototype.mousedragscrollable = function () {
      let target;
      $(this).each(function (i, e) {
        $(e).mousedown(function (event) {
          event.preventDefault();
          target = $(e);
          $(e).data({
            down: true,
            move: false,
            x: event.clientX,
            y: event.clientY,
            scrollleft: $(e).scrollLeft(),
            scrolltop: $(e).scrollTop(),
          });
          return false;
        });
        $(e).click(function (event) {
          if ($(e).data("move")) {
            return false;
          }
        });
      });
      $(document)
        .mousemove(function (event) {
          if ($(target).data("down")) {
            event.preventDefault();
            let move_x = $(target).data("x") - event.clientX;
            let move_y = $(target).data("y") - event.clientY;
            if (move_x !== 0 || move_y !== 0) {
              $(target).data("move", true);
            } else {
              return;
            }
            $(target).scrollLeft($(target).data("scrollleft") + move_x);
            $(target).scrollTop($(target).data("scrolltop") + move_y);
            return false;
          }
        })
        .mouseup(function (event) {
          $(target).data("down", false);
          return false;
        });
    };
    $(".article_wrapper").mousedragscrollable();
  }
});

// モーダル
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".micromodal")) {
    MicroModal.init({
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      disableScroll: true,
      disableFocus: true,
    });
  }
});

// ドラムファミリーの会話風アニメーション
jQuery(function ($) {
  if ($(".drum_fade").length > 0) {
    // 画面に入った要素から順番に起動
    // $(document).ready(function() {
    // 	checkAndAddClass();

    // 	function checkAndAddClass() {
    // 		$('.drum_fade').each(function(index) {
    // 			var $element = $(this);
    // 			var position = $element.offset().top;
    // 			var windowHeight = $(window).height();
    // 			var scroll = $(window).scrollTop();

    // 			if (position < scroll + windowHeight && position + $element.outerHeight() > scroll) {
    // 				setTimeout(function() {
    // 				$element.addClass('talk_visible');
    //     			}, index * 800);
    // 			}
    // 		});
    // 	}

    // 	$(window).scroll(function() {
    // 		checkAndAddClass();
    // 	});
    // });

    // .sec_drum_leadが画面に入ったら全要素起動
    $(document).ready(function () {
      checkAndAddClass();

      function checkAndAddClass() {
        var $drumTalkElements = $(".drum_fade");
        var $secDrumLead = $(".sec_drum_lead");
        var secDrumLeadPosition = $secDrumLead.offset().top;

        if (secDrumLeadPosition < $(window).scrollTop() + $(window).height()) {
          $drumTalkElements.each(function (index) {
            setTimeout(
              function () {
                $(this).addClass("talk_visible");
              }.bind(this),
              index * 1000
            );
          });
        }
      }

      $(window).scroll(function () {
        checkAndAddClass();
      });
    });
  }
});

jQuery(function ($) {
  if ($(".topBusiness__img").length > 0) {
    $(window).scroll(function () {
      for (var i = 1; i <= 4; i++) {
        if ($(".js-scroll-txt0" + i).offset().top < $(window).scrollTop() + 300) {
          $(".topBusiness__img p").removeClass("active");
          $(".topBusiness__img p:nth-child(0" + i + ")").addClass("active");
        }
      }
    });
  }
});
